/**
 * Disable submit button in a Sulu Form to prevent multiple entries at once.
 * For example when a user presses 10 times on the submit button,
 * more than 10 emails will be sent at the same time
 */
document.querySelectorAll("form[name^='dynamic_form']").forEach((form) => {
	form.addEventListener('submit', function () {
		this.querySelector("[type='submit']").setAttribute('disabled', 'disabled');
	});
});

/**
 * Change label for file input when a file is selected
 * in order to display the selected file name inside the label
 */
document.querySelectorAll("[class='custom-file']").forEach((fileInputContainer) => {
	const fileInput = fileInputContainer.querySelector("input[class*='custom-file-input']");
	const label = fileInputContainer.querySelector('.custom-file-label');

	fileInput.addEventListener('change', function () {
		if (!fileInput.files || fileInput.files.length === 0) {
			return (label.innerHTML = '');
		}

		return (label.innerHTML = fileInput.files[0].name);
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const params = new URLSearchParams(location.search);

	if (params.get('send') === 'true') {
		const form = document.querySelector(`.pane-${params.get('formId')}`);

		if (form !== null) {
			$('html,body').animate(
				{
					scrollTop: $(form).offset().top - 100,
				},
				500,
				'swing'
			);
		}
	}
});


/**
 * Customer service form select
 */

document.querySelectorAll(".maintenance-planner-select").forEach((select) => {
    const selectFields = select.getElementsByTagName("select");
    for (var i = 0; i < selectFields.length; i++) {
        selectFields[i].addEventListener("change", function() {
            let inputsDisabled = false;
            const selectId = this.getAttribute('id');
            const index = selectId.lastIndexOf('_');
            const formId = selectId.substring(0, index);

            if(disableAllInputs(this.value)) {
                inputsDisabled = true;
            }

            setInputs(formId, 'input', inputsDisabled);
            setInputs(formId, 'textarea', inputsDisabled);
            setInputs(formId, 'button', inputsDisabled);
            setInputs(formId, 'select', inputsDisabled);
            showMaintenancePlanner(select, inputsDisabled);
        });
    }
});

function showMaintenancePlanner(element, show) {
    if (show) {
        const alert = document.getElementById('onderhoudsplanner-alert');
        if (alert) return;
        const arrow = '<svg class="btn__arrow icon icon--20 icon--arrow-right" width="24" height="14" viewBox="0 0 24 14" xmlns="http://www.w3.org/2000/svg"><path d="M23.546 7.604a.613.613 0 00.05-.09c.02-.035.04-.07.057-.107.013-.036.024-.073.034-.111a.702.702 0 00.029-.099A1.15 1.15 0 0023.739 7v-.026a1.15 1.15 0 00-.023-.21.702.702 0 00-.029-.098c0-.04-.02-.076-.034-.112-.013-.036-.04-.073-.057-.109a.937.937 0 00-.18-.246L17.697.5a1.146 1.146 0 00-1.613.002 1.129 1.129 0 00.001 1.603l3.757 3.734H1.403c-.42-.02-.818.191-1.034.55a1.13 1.13 0 000 1.167c.216.36.614.571 1.034.551h18.439l-3.757 3.736a1.129 1.129 0 00-.001 1.603 1.146 1.146 0 001.613.002l5.708-5.67a.937.937 0 00.141-.174z" fill="currentColor" fill-rule="evenodd"/></svg>'
        element.insertAdjacentHTML('afterend', '<div id="onderhoudsplanner-alert" class="alert alert-onderhoudsplanner w-100"><span class="d-block my-2">Voor dit onderwerp verwijzen we je graag door naar onze service afspraak planner.</span><a href="/service/maak-een-service-afspraak" class="btn my-2 btn-md-inline btn-secondary"><span class="btn__text">Afspraak plannen</span>' + arrow + '</a></div>');
    }
    else {
        const alert = document.getElementById('onderhoudsplanner-alert');
        if (alert) {
            alert.remove();
        }
    }
}

function setInputs(formId, input, disabled) {
    const formDiv = document.getElementById(formId);
    if (formDiv) {
        if (input === 'select') {
            const selectFields = formDiv.getElementsByTagName("select");
            for (let i = 0; i < selectFields.length; i++) {
                if (!selectFields[i].parentElement.classList.contains('maintenance-planner-select')) {
                    selectFields[i].disabled = disabled;
                }
            }
        } else {
            const fields = formDiv.getElementsByTagName(input);
            for (let i = 0; i < fields.length; i++) {
                fields[i].disabled = disabled;
            }
        }
    }
}

function disableAllInputs(value) {
    let disableInputs = false;
    switch(value) {
        case '1e afstelbeurt winkel':
            disableInputs = true;
            return disableInputs;
        case 'Onderhoudsbeurt winkel':
            disableInputs = true;
            return disableInputs;
        case 'Onderhoudsbeurt aan huis':
            disableInputs = true;
            return disableInputs;
        case 'Reparatieaanvraag n.a.v. pechhulp':
            disableInputs = true;
            return disableInputs;
        case 'Banden':
            disableInputs = true;
            return disableInputs;
        case 'Spaken':
            disableInputs = true;
            return disableInputs;
        case 'Remmen':
            disableInputs = true;
            return disableInputs;
        case 'Ketting':
            disableInputs = true;
            return disableInputs;
        case 'Versnelling':
            disableInputs = true;
            return disableInputs;
        case 'Pedalen':
            disableInputs = true;
            return disableInputs;
        case 'Accu':
            disableInputs = true;
            return disableInputs;
        case 'Display':
            disableInputs = true;
            return disableInputs;
        case 'Bedieningspaneel':
            disableInputs = true;
            return disableInputs;
        case 'Motor':
            disableInputs = true;
            return disableInputs;
        case 'Verlichting':
            disableInputs = true;
            return disableInputs;
        default:
            disableInputs = false;
            return disableInputs;
    }
}
